import { useQuery } from "@tanstack/react-query";
import ApiHttp from "byzantine/src/ApiHttp";
import { LIVE_LEDGER_ENRICHMENT_PARAMS } from "byzantine/src/TransactionEnrichmentSource";

import { TRANSACTION_DETAIL_QUERY_KEY } from "../constants";

import type { TransactionPayload } from "byzantine/src/types/models/v1/Transaction.types";

export const fetchTransactionDetail = async (
  transactionId: string
): Promise<API.Transaction> => {
  const { transaction } = await ApiHttp.fetch<TransactionPayload>(
    `transactions/${transactionId}/`,
    { method: "GET" },
    {
      include_bai2: "true",
      include_receipts: "true",
      include_account_type: "true",
      ...LIVE_LEDGER_ENRICHMENT_PARAMS,
    }
  );
  return transaction;
};

// Exported so other callers priming the cache via queryClient.fetchQuery can't drift from this hook's key/fetcher/options.
export const transactionDetailQueryOptions = (transactionId: string) => ({
  queryKey: [TRANSACTION_DETAIL_QUERY_KEY, transactionId],
  queryFn: () => fetchTransactionDetail(transactionId),
  staleTime: 60_000,
  gcTime: 60_000,
  retry: false,
});

export const useTransactionDetail = (transactionId: string | null) => {
  return useQuery<API.Transaction>({
    ...transactionDetailQueryOptions(transactionId as string),
    enabled: transactionId !== null,
  });
};
